import { useState } from 'react';

const colors = {
  bg: '#f0f1f3',
  cardBg: '#ffffff',
  navy: '#071a52',
  greenDark: '#5cb83c',
  textPrimary: '#1a1a2e',
  textSecondary: '#6b7280',
  border: '#e2e4e8',
};

const CORRECT_USER = 'jmcorbett83@gmail.com';
const CORRECT_PASS = 'Jkee722026!!';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function handleSubmit() {
    setLoading(true);
    setError('');
    setTimeout(() => {
      if (username.trim() === CORRECT_USER && password === CORRECT_PASS) {
        localStorage.setItem('ba_auth', 'true');
        onLogin();
      } else {
        setError('Incorrect username or password.');
      }
      setLoading(false);
    }, 400);
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: colors.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Outfit', sans-serif",
      padding: '20px',
    }}>
      <div style={{ width: '100%', maxWidth: '360px' }}>

        {/* Logo / wordmark */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '2.4rem', fontWeight: 800, color: colors.navy, lineHeight: 1 }}>
            brick<span style={{ fontWeight: 400, color: colors.greenDark }}>audit</span>
          </div>
          <div style={{ fontSize: '0.78rem', color: colors.textSecondary, marginTop: '6px' }}>
            Every Brick Accounted For
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: colors.cardBg,
          border: `1px solid ${colors.border}`,
          borderRadius: '8px',
          padding: '28px 24px',
        }}>
          <div style={{ fontSize: '0.72rem', fontWeight: 700, color: colors.textSecondary, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '16px' }}>
            Sign In
          </div>

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{
              width: '100%',
              padding: '12px 14px',
              background: '#f9fafb',
              border: `1px solid ${colors.border}`,
              borderRadius: '6px',
              color: colors.textPrimary,
              fontFamily: "'Outfit', sans-serif",
              fontSize: '0.95rem',
              outline: 'none',
              marginBottom: '10px',
              boxSizing: 'border-box',
            }}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            style={{
              width: '100%',
              padding: '12px 14px',
              background: '#f9fafb',
              border: `1px solid ${colors.border}`,
              borderRadius: '6px',
              color: colors.textPrimary,
              fontFamily: "'Outfit', sans-serif",
              fontSize: '0.95rem',
              outline: 'none',
              marginBottom: '16px',
              boxSizing: 'border-box',
            }}
          />

          {error && (
            <div style={{
              background: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '6px',
              padding: '10px 14px',
              fontSize: '0.82rem',
              color: '#dc2626',
              marginBottom: '14px',
              fontWeight: 600,
            }}>{error}</div>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: '100%',
              padding: '13px 24px',
              background: loading ? colors.border : colors.navy,
              color: loading ? colors.textSecondary : '#ffffff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: 800,
              fontFamily: "'Outfit', sans-serif",
              cursor: loading ? 'default' : 'pointer',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.7rem', color: colors.textSecondary }}>
          brickaudit.com · JayKay Bricks
        </div>
      </div>
    </div>
  );
}

export default Login;